import styled, { keyframes } from 'styled-components/macro';
const SpinnerKeyframes = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;
export const Spinner = styled.span`
    display: inline-block;
    font-size: 10px;
    text-indent: -9999em;
    width: 2em;
    height: 2em;
    border-radius: 50%;
    background: ${(props) => props.theme.colors.widgets.color};
    background: linear-gradient(
        to right,
        ${(props) => props.theme.colors.widgets.color} 10%,
        rgba(255, 255, 255, 0) 42%
    );
    position: relative;
    animation: ${SpinnerKeyframes} 0.8s infinite linear;
    transform: translateZ(0);
    mask-image: radial-gradient(circle farthest-side at center, transparent 59%, white 60%);
    &:before {
        width: 50%;
        height: 50%;
        background: ${(props) => props.theme.colors.widgets.color};
        border-radius: 100% 0 0 0;
        position: absolute;
        top: 0;
        left: 0;
        content: '';
    }
`;
